export default remote => ({
    newAlert: (data) => remote.post('flight/alert', data),
    deactivate: (code) => remote.delete(`flight/alert/${code}`)
});
